import React, { createContext, useState, useContext } from "react";
import Notification from "../../partials/notification";
import Loading from "../../partials/loading";
import CustomModal from "../../partials/modal";
import RightDrawer from "../../partials/rightDrawer";

const GlobalContext = createContext();

export const useGlobalContext = () => {
    return useContext(GlobalContext);
};

const GlobalProvider = ({ children }) => {
    const [notification, setNotification] = useState({
        open: false,
        message: "",
        severity: "info",
    });
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    // State quản lý RightDrawer
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerContent, setDrawerContent] = useState(null);
    const [drawerCloseCallback, setDrawerCloseCallback] = useState(null); // Thêm callback

    const showNotification = (message, severity = "info") => {
        setNotification({ open: true, message, severity });
    };

    const handleCloseNotification = () => {
        setNotification({ ...notification, open: false });
    };

    const showLoading = () => setLoading(true);
    const hideLoading = () => setLoading(false);

    const openModal = (content) => {
        setModalContent(content);
        setModalOpen(true);
    };
    const closeModal = () => {
        setModalContent(null);
        setModalOpen(false);
    };

    const openDrawer = (content, onCloseCallback = null) => {
        setDrawerContent(content);
        setDrawerOpen(true);
        setDrawerCloseCallback(() => onCloseCallback); // Lưu callback khi mở
    };

    const closeDrawer = () => {
        setDrawerContent(null);
        setDrawerOpen(false);
        if (drawerCloseCallback) {
            drawerCloseCallback(); // Gọi callback khi đóng
        }
    };

    return (
        <GlobalContext.Provider
            value={{
                showNotification,
                showLoading,
                hideLoading,
                openModal,
                closeModal,
                openDrawer,
                closeDrawer,
            }}
        >
            {children}
            <Notification
                open={notification.open}
                handleClose={handleCloseNotification}
                message={notification.message}
                severity={notification.severity}
            />
            {loading && <Loading />}
            <CustomModal open={modalOpen} handleClose={closeModal}>
                {modalContent}
            </CustomModal>
            <RightDrawer open={drawerOpen} onClose={closeDrawer}>
                {drawerContent}
            </RightDrawer>
        </GlobalContext.Provider>
    );
};

export default GlobalProvider;
